import React from "react";
import { HolidayCalendarContainer } from "../../../containers";

const HolidayCalendar = (props) => {
  return <HolidayCalendarContainer {...props} />;
};

export default HolidayCalendar;
